import { VARIANT, VARIANT_A } from '../../experiments/experimentDefaults';
import { ExperimentFetchStatus } from '../../experiments/ExperimentFetchStatus';
import { ExperimentIdentifier } from '../../experiments/ExperimentIdentifier';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getExperiment } from '../../experiments/Experiments';
import { experimentsEnabled } from '../../experiments/ExperimentUtils';
import { getUserExperimentIdentifier } from '../../experiments/getUserExperimentIdentifier';
import { isPostVerification } from '../../flow-settings/settingsSelectors';
export const getExperimentFromState = (state, experimentId) => {
  return state.experiments.treatments[experimentId];
};
export const getExperimentsFromState = state => {
  return state.experiments.treatments;
};
export const getUnenrolledExperiments = state => {
  return state.experiments.unenrolledExperiments;
};
export const isExperimentActive = (state, experimentId) => {
  const experiment = getExperimentFromState(state, experimentId);
  const experimentObject = getExperiment(experimentId);
  if (!experiment || !experimentObject) return false;
  return experimentsEnabled() && experimentObject.shouldEnroll(state);
};
export const isCopyExperimentActive = (state, experimentId) => {
  const experiment = getExperimentFromState(state, experimentId);
  if (!experiment) return false;
  return experiment.status && experiment.status.isActive && !experiment.status.isDefaulted;
};
export const arePreAccountCreatedExperimentsFetched = state => {
  return state.experiments.experimentsStatus[ExperimentIdentifier.Utk] === ExperimentFetchStatus.Fetched || state.experiments.experimentsStatus[ExperimentIdentifier.Uuid] === ExperimentFetchStatus.Fetched;
};
export const arePortalExperimentsFetched = state => {
  return state.experiments.experimentsStatus[ExperimentIdentifier.PortalId] === ExperimentFetchStatus.Fetched;
};
export const getExperimentIdentifierPhase = state => {
  return state.experiments.identifierPhase;
};
export const getParameter = (state, experimentId) => {
  const experiment = getExperimentFromState(state, experimentId);
  if (!experiment) return '';
  return experiment.parameters.group;
};
export const getHasExposureBeenTracked = (state, experimentId) => {
  const experiment = getExperimentFromState(state, experimentId);
  if (!experiment) return false;
  return experiment.trackedExposure;
};
export const getIsAssignedToVariant = (state, experimentId, variantsToCheck = [VARIANT]) => {
  const parameter = getParameter(state, experimentId);
  return variantsToCheck.includes(parameter);
};
export const getIsActiveAndAssignedToVariant = (state, experimentId, variantsToCheck = [VARIANT]) => {
  if (!experimentsEnabled()) return false;
  const parameter = getParameter(state, experimentId);
  const experimentActive = isExperimentActive(state, experimentId);
  const isInVariants = variantsToCheck.includes(parameter);
  return isInVariants && experimentActive;
};
export const getIsActiveAndAssignedToVariantONBC008 = state => {
  return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ONBC008);
};
export const getIsActiveAndAssignedToVariantACQ125 = state => {
  return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ125, [VARIANT_A]);
};
export const getIsActiveAndAssignedToVariantACQ126 = state => {
  return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ126, [VARIANT_A]);
};
export const getActiveExperimentsIds = state => {
  const experimentsFromState = getExperimentsFromState(state);
  const unenrolledExperiments = getUnenrolledExperiments(state);

  if (!experimentsFromState) {
    return [];
  }

  const experimentKeys = Object.keys(experimentsFromState);
  const activeExperiments = experimentsFromState ? experimentKeys.filter(experimentId => isExperimentActive(state, experimentId) && !unenrolledExperiments.includes(experimentId)) : [];
  return activeExperiments;
};
export const getActiveExperimentIdsFromCompleteVerification = state => state.experiments.activeExperimentsParameters;
export const getExperimentUtk = state => {
  return state.experiments.experimentUtk;
};
export const getPreAccountCreatedExperimentIdentifier = state => {
  return isPostVerification() ? getExperimentUtk(state) || getUserExperimentIdentifier() : getUserExperimentIdentifier();
};